module.exports = __webpack_public_path__ + "img/pancreas.fde49e7e.png";